import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { Store } from '@ngrx/store';
import { activeClientActions } from '@shared/store/active-client/active-client.actions';

// Global routes only: client routes get their active client from the URL through clientCodeGuard, and hydrating
// there too would race with it on a cold load and overwrite the URL's client with the persisted one.
export const hydrateActiveClientGuard: CanActivateFn = () => {
  inject(Store).dispatch(activeClientActions.hydrate());
  return true;
};
